<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="title"
    width="800px"
    :close-on-click-modal="false"
    append-to-body
    class="app-main-inner"
  >
    <div class="app-main-inner-row" style="padding-bottom: 20px;">
      <el-form label-width="70px" label-position="left" style="width: 100%">
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$t('SeaExport.HsCode')">
              <el-input v-model="filter.code" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('queryJob.chineseDescriptionOfGoods')">
              <el-input v-model="filter.commodityName" />
            </el-form-item>
          </el-col>
          <el-col v-if="!hideCountryCode" :span="8">
            <el-form-item :label="$t('SeaExport.countryCode')">
              <el-input v-model="filter.countryCode" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-button type="primary" @click="toQuery">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
            <el-button type="primary" @click="reset">{{ $t('CargoMsg.Cargo_Empty') }}</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <cargo-ag-grid
      :grid-params.sync="girdParams"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
      :enable-col-resize="true"
      style="width:100%;height:300px"
      @gridReady="params=>{gridApi=params.api}"
    />
    <span slot="footer">
      <el-button type="primary" @click="choose">{{ $t('CargoMsg.Cargo_ConfirmR') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>

import { HsCode } from '@/class/model/mdm/HsCode'
import { getLoading } from '@/utils/utilBaseElement'

export default {
  name: 'HsCodeSearchDialog',
  components: { },
  props: {
    visible: { type: Boolean, required: true },
    title: { type: String, required: true },
    hideCountryCode: { type: Boolean, default: false }
  },
  data() {
    return {
      loading: null,
      innerVisible: false,
      filter: {
        code: '',
        commodityName: '',
        countryCode: 'CN'
      },
      girdParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowClicked: event => { this.selectedRow = event.data }
      },
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_HsCode'),
          field: 'code',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_EnglishCargoName') + '(MSC)',
          field: 'mscCommodity',
          width: 230
        }, {
          headerName: this.$t('CargoMsg.Cargo_ChineseCargoName'),
          field: 'commodityName',
          width: 330
        }
      ],
      rowData: [],
      selectedRow: null,
      gridApi: null
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.filter.code = ''
        this.filter.commodityName = ''
        this.filter.countryCode = 'CN'
        this.rowData = []
        this.selectedRow = null
      }
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    async toQuery() {
      this.filter.branch = this.$store.getters.currentOfficeId
      this.loading = getLoading()
      this.rowData = await HsCode.queryHsCode(this.filter).finally(() => {
        this.loading.close()
      })
    },
    choose() {
      if (!this.selectedRow) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.$emit('callback', this.selectedRow)
      this.innerVisible = false
    },
    reset() {
      for (const key in this.filter) {
        this.filter[key] = ''
      }
    }
  }
}
</script>

<style scoped lang="scss">
.app-main-inner .app-main-inner-row ::v-deep {
  .el-form-item__label {
    font-size: 12px;
    font-weight: normal;
  }
}
</style>
